module.exports = __webpack_public_path__ + "static/media/ride.b0d70ec5.wav";


//////////////////
// WEBPACK FOOTER
// ./src/audio/row3/ride.wav
// module id = 59
// module chunks = 0